import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import JsonView from "@uiw/react-json-view";

const MessageAccordion = ({ type, content, name }) => {
  let title = "";
  if (name === "execute_fql_command") {
    if (type === "function_call") {
      title = "Executing fql commands ...";
    } else if (type === "function_call_output") {
      title = "Fql commands executed";
    } else {
      throw new Error("Invalid message");
    }
  }

  return (
    <Accordion allowToggle>
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              _expanded={{ bg: "gray.700", color: "white" }}
              _hover={{ bg: "gray.700", color: "white" }}
              bg={"gray.500"}
              color={"white"}
              borderRadius="md"
              py={2}
              gap={3}
            >
              <AccordionIcon />
              <Box as="span" flex="1" textAlign="left">
                {title}
              </Box>
            </AccordionButton>
            <AccordionPanel pb={4}>
              <Box
                borderRadius="md"
                p={2}
                bg="gray.50"
                maxHeight="300px"
                overflowY="auto"
              >
                <JsonView
                  value={content}
                  displayDataTypes={false}
                  displayObjectSize={false}
                  collapsed={false}
                />
              </Box>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};

export default MessageAccordion;
